import styled from "styled-components";



export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`  

export const FilterItem = styled.div`
  padding: 10px 20px;
  border-radius: 30px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  font-family: var(--FilterItemFont-family);
  background-color: ${props => props.selected ? "rgb(37, 85, 239)" : "rgb(255, 255, 255)"};
  color: ${props => props.selected ? "rgb(255, 255, 255)" : "inherit"};
  transition: all 0.2s ease-in-out;
`